<p-card styleClass="very-compact-card p-3">
  <div class="flex align-items-center justify-content-between flex-wrap gap-2">
    <div class="flex align-items-center gap-2">
      <h3 class="m-0">Разбитые документы</h3>
      <crm-button-show-and-hide
        [isShow]="documentsInfo.documentsShow"
        (isShowChange)="showButtonChange($event)"></crm-button-show-and-hide>
    </div>
  </div>

  <div
    *ngIf="documentsInfo.documentsShow"
    class="mt-3">
    <div class="max-h-29rem overflow-y-auto overflow-x-hidden">
      <crm-table
        *ngIf="!documentsInfo.loading && documentsInfo.documents?.length"
        name="split-documents"
        [columns]="columns"
        [loading]="documentsInfo.loading"
        [values]="documentsInfo.documents"
        styleClass="p-datatable-sm">
        <ng-template
          #rowTemplate
          let-document="item">
          <tr *ngIf="toDocument(document) as document">
            <td>
              <a
                (click)="editDocument(document.code)"
                class="cursor-pointer white-space-nowrap">
                {{ document.code }}
              </a>
              <p class="text-gray-500">{{ document.date | date: 'dd.MM.yyyy' }}</p>
            </td>
            <td>
              {{ document.amount | number: '.0-0' }}
            </td>
          </tr>
        </ng-template>
        <ng-template #footerTemplate>
          <tr>
            <td></td>
            <td>
              <p class="font-bold">
                {{ documentsInfo.documents | sum: 'amount' | number }}
              </p>
            </td>
          </tr>
        </ng-template>
      </crm-table>

      <p
        *ngIf="!documentsInfo.documents?.length && !documentsInfo.loading"
        class="text-xl font-medium">
        Нет разбитых документов
      </p>

      <crm-spinner *ngIf="documentsInfo.loading"></crm-spinner>
    </div>

    <div class="flex">
      <a
        *ngIf="documentsInfo.documents?.length && !documentsInfo.loading"
        label="в реестр"
        class="p-button-round p-button-text p-button-sm p-button-info cursor-pointer -ml-3"
        icon="pi pi-external-link"
        (click)="directToDocumentsList()"></a>
    </div>
  </div>
</p-card>
